// Stores
import { useResult } from "../../../../shared/formContext/hooks/useResult";

// Components
import ConditionContent from './../../../../components/ConditionContent/ConditionContent';
import Cta from "./../../../../components/Cta/Cta";
import Box from "./../../../../components/Box/Box.js";
import ShareFullLink from "../../../../shared/components/ShareFullLink";

// Views
import TableView from './../../Views/TableView';

// Helpers
import {utils} from "../../../../helpers";
import {__} from "@wordpress/i18n";

// WP react stuff
import {useState, useEffect} from '@wordpress/element';


type ResponseData = {
    monthly: {
        save_amount: number;
        level: string;
        new_amount: number;
        old_amount: number;
    };
    interest_rate: {
        save_amount: number;
        level: string;
        new_amount: number;
        old_amount: number;
    };
    total: {
        save_debit: number,
        new_debit: number,
        old_debit: number,
        save_amount: number
        new_amount: number;
        old_amount: number;
    }
};

type TopBoxData = {
    title: string;
    info: number;
    color: string;
};

type Condition = {
    level: string;
    newAmount: number;
    oldAmount: number;
    labels: {
        lower: string;
        higher: string;
        equal: string;
    };
    finalText: string;
    lineThrough: boolean;
};

const LoanSavings: React.FC = () => {
    const { resultData } = useResult();
    const { response, loading } = resultData as {
        response: { data: { result: ResponseData } } | null;
        loading: boolean;
    };

    const [topBox, setTopBox] = useState<TopBoxData | null>(null);
    const [conditionsContent, setConditionsContent] = useState<Condition[] | null>(null);

    useEffect(() => {
        if (response) {
            const {monthly, interest_rate: interestRate} = response.data.result;

            const info = monthly.save_amount;
            let color: string = '';
            let title: string = '';

            if (monthly.level === 'equal') {
                title = __('Vai poupar mensalmente:', "df-simulators");
                color = 'yellow-100';
            } else if (monthly.level == 'lower') {
                title = __('Vai poupar mensalmente:', "df-simulators");
                color = 'green-100';
            } else if (monthly.level === 'higher') {
                title = __('Prestação mensal aumenta em:', "df-simulators");
                color = 'red-100';
            }

            setTopBox({
                title,
                info,
                color,
            });

            const conditions: Condition[] = [
                {
                    level: monthly.level,
                    newAmount: monthly.new_amount,
                    oldAmount: monthly.old_amount,
                    labels: {
                        lower: __('A prestação do novo crédito é menor que a atual:', 'df-simulators'),
                        higher: __('Fica a pagar uma prestação de:', 'df-simulators'),
                        equal: __('A prestação do novo crédito é igual que a atual:', 'df-simulators'),
                    },
                    finalText: '{label}',
                    lineThrough: true,
                },
                {
                    level: interestRate.level,
                    newAmount: interestRate.new_amount,
                    oldAmount: interestRate.old_amount,
                    labels: {
                        lower: __('Valor dos juros totais diminui em:', 'df-simulators'),
                        higher: __('Valor dos juros totais aumenta em:', 'df-simulators'),
                        equal: __('Os juros totais do novo crédito são os mesmos que os atuais:', 'df-simulators'),
                    },
                    finalText: '{label}',
                    lineThrough: false,
                },
            ];

            setConditionsContent(conditions);
        }
    }, [response]);

    return (
        <div className="transferencia-credito">
            {topBox && (
                <Box
                    grid
                    loading={loading}
                    header={{
                        title: topBox.title,
                        info: utils.toEuro(topBox.info),
                        color: topBox.color,
                    }}
                >
                    {conditionsContent &&
                        conditionsContent.map((condition, index) => (
                            <ConditionContent key={index} {...condition} />
                        ))}
                </Box>
            )}

            {response && (
                <Box
                    loading={loading}
                    header={{
                        title: __('Comparação dos créditos', 'df-simulators'),
                    }}
                >
                    <TableView/>
                </Box>
            )}
            {/* Share Simulation button */}
            <ShareFullLink />

            {/* Call-to-Action - Standard project pattern */}
            <Cta/>
        </div>
    );
};

export default LoanSavings;
